import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { useDispatch, useSelector } from "react-redux";
import { setUnauthorized } from "../../store/features/userSelector";
import { Link, useLocation } from "react-router-dom";
import "./menu.scss";

const MenuComponent = () => {
  const dispatch = useDispatch();
  const statistics = useSelector((state) => state.userSelector.statistics);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElService, setAnchorElService] = useState(null);
  const [mobileMenuAnchorEl, setMobileMenuAnchorEl] = useState(null);
  const [mobileMenuAnchorElService, setMobileMenuAnchorElService] =
    useState(null);
  const location = useLocation();

  const logout = () => {
    dispatch(setUnauthorized());
    window.location.reload();
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleServiceMenuOpen = (event) => {
    setAnchorElService(event.currentTarget);
  };

  const handleServiceMenuClose = () => {
    setAnchorElService(null);
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMenuAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuAnchorEl(null);
  };

  const isActive = (path) => location.pathname === path;

  const isActiveService = (path) => location.pathname === path;

  const formatNumber = (num) => {
    return Math.round(num)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  return (
    <AppBar component="nav">
      <Toolbar>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={handleMobileMenuOpen}
          sx={{ display: { sm: "none" } }}
        >
          <MenuIcon />
        </IconButton>
        <Button
          sx={{ color: "#fff", display: { xs: "none", sm: "block" } }}
          onClick={handleMenuOpen}
          className={
            isActive("/RZN-S-") || isActive("/so10") || isActive("/law")
              ? "active"
              : ""
          }
        >
          База клиентов
        </Button>
        <Link to={"/tasks"}>
          <Button
            sx={{ color: "#fff", display: { xs: "none", sm: "block" } }}
            className={isActive("/tasks") ? "active" : ""}
          >
            Задачи
          </Button>
        </Link>
        {/* <Link to='/service'>
                    <Button
                        sx={{ color: '#fff', display: { xs: 'none', sm: 'block' } }}
                        className={isActive('/service') ? 'active' : ''}
                    >
                        Обслуживание
                    </Button>
                </Link> */}
        <Button
          sx={{ color: "#fff", display: { xs: "none", sm: "block" } }}
          onClick={handleServiceMenuOpen}
          className={
            isActive("/service/RZN-S-") ||
            isActiveService("/service/so10") ||
            isActiveService("/service/law")
              ? "active"
              : ""
          }
        >
          Обслуживание
        </Button>
        <Link to="/inventory">
          <Button
            sx={{ color: "#fff", display: { xs: "none", sm: "block" } }}
            className={isActive("/inventory") ? "active" : ""}
          >
            Склад
          </Button>
        </Link>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <Link onClick={handleMenuClose} to="/RZN-S-">
            <Button
              sx={{ color: "#fff" }}
              className={isActive("/RZN-S-") ? "active" : ""}
            >
              SMART
            </Button>
          </Link>
          <Link onClick={handleMenuClose} to="/so10">
            <Button
              sx={{ color: "#fff" }}
              className={isActive("/so10") ? "active" : ""}
            >
              СО10
            </Button>
          </Link>
          <Link onClick={handleMenuClose} to="/law">
            <Button
              sx={{ color: "#fff" }}
              className={isActive("/law") ? "active" : ""}
            >
              Юр. лица
            </Button>
          </Link>
        </Menu>

        <Menu
          anchorEl={anchorElService}
          open={Boolean(anchorElService)}
          onClose={handleServiceMenuClose}
        >
          <Link onClick={handleServiceMenuClose} to="/service/RZN-S-">
            <Button
              sx={{ color: "#fff" }}
              className={isActiveService("/service/RZN-S-") ? "active" : ""}
            >
              SMART
            </Button>
          </Link>
          <Link onClick={handleServiceMenuClose} to="/service/so10">
            <Button
              sx={{ color: "#fff" }}
              className={isActiveService("/service/so10") ? "active" : ""}
            >
              СО10
            </Button>
          </Link>
          <Link onClick={handleServiceMenuClose} to="/service/law">
            <Button
              sx={{ color: "#fff" }}
              className={isActiveService("/service/law") ? "active" : ""}
            >
              Юр. лица
            </Button>
          </Link>
        </Menu>

        <Menu
          anchorEl={mobileMenuAnchorEl}
          open={Boolean(mobileMenuAnchorEl)}
          onClose={handleMobileMenuClose}
        >
          <MenuItem>
            <Link
              to="/RZN-S-"
              className={`mobileMenuButton ${isActive("/RZN-S-") ? "active" : ""}`}
            >
              SMART
            </Link>
          </MenuItem>
          <MenuItem>
            <Link
              to="/so10"
              className={`mobileMenuButton ${isActive("/so10") ? "active" : ""}`}
            >
              СО10
            </Link>
          </MenuItem>
          <MenuItem>
            <Link
              to="/law"
              className={`mobileMenuButton ${isActive("/law") ? "active" : ""}`}
            >
              Юр. лица
            </Link>
          </MenuItem>
          <MenuItem>
            <Link
              to="/tasks"
              className={`mobileMenuButton ${isActive("/tasks") ? "active" : ""}`}
            >
              Задачи
            </Link>
          </MenuItem>
          <MenuItem>
            <Link
              to="/service"
              className={`mobileMenuButton ${isActive("/service") ? "active" : ""}`}
            >
              Обслуживание
            </Link>
          </MenuItem>
          <MenuItem>
            <Link
              to="/inventory"
              className={`mobileMenuButton ${isActive("/inventory") ? "active" : ""}`}
            >
              Склад
            </Link>
          </MenuItem>
          <MenuItem>
            <Button
              onClick={(logout, handleMobileMenuClose)}
              sx={{ color: "#fff", paddingLeft: "0" }}
              variant="text"
            >
              Выйти
            </Button>
          </MenuItem>
        </Menu>
        <div className="logoutButton">
          <p>{statistics && `Должны: ${statistics.total_debt}`}</p>
          <p>{statistics && `Станции: ${statistics.total_count}`}</p>
          <p>
            {statistics &&
              `Доход: ${formatNumber(statistics.toyal_monthly_income)} ₽`}{" "}
          </p>
          <Button onClick={logout} variant="text">
            Выйти
          </Button>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default MenuComponent;
